<script setup lang="ts">
import type { BaseButtonProps } from '@/components/button/base-button.vue';

import BaseButton from '@/components/button/base-button.vue';

type Props = Omit<BaseButtonProps, 'color'>;

const props = defineProps<Props>();
</script>

<template>
   <BaseButton v-bind="props" color="dark">
      <slot />
   </BaseButton>
</template>

<style scoped>

</style>
